module.exports = __webpack_public_path__ + "static/media/html.58c119ae.png";